import { Authority } from 'platform/app/authority.constant';

export const ADVERTISERS = {
    name: 'Advertisers',
    path: '/admin-panel/advertisers',
    requiresAuthority: Authority.ROLE_ADMIN_PANEL_VIEW_EDIT,
};
